import { Component, OnInit } from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public isMobile: boolean = false;

  offersChartOptions = {
    series: [
      {
        name: "Desktops",
        data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
      }
    ],
    chart: {
      
      type: "line",
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "straight"
    },

    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5
      }
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep"
      ]
    }
  }
  locationChartOptions = {
    series: [34, 66],
    chart: {
      
      type: "pie"
    },
    labels: ["Leonardo's Pizza", "Five Guys"],
    // responsive: [
    //   {
    //     breakpoint: 480,
    //     options: {
    //       chart: {
    //         width: 200
    //       },
    //       legend: {
    //         position: "bottom"
    //       }
    //     }
    //   }
    // ]
  };
  customerChartOptions = {
    series: [
      {
        name: "Five Guys",
        data: [44, 55, 41, 37, 22, 43, 21]
      },
      {
        name: "Leonardo's Pizza",
        data: [53, 32, 33, 52, 13, 43, 32]
      },
    ],
    chart: {
      type: "bar",
    },

    xaxis: {
      categories: ["Jan", "Feb",  "Mar",  "Apr",  "May",  "Jun",  "Jul",  "Aug", "Sep"]
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
      offsetX: 40
    }
  };

  constructor(breakpointObserver: BreakpointObserver) { 
    breakpointObserver.observe(['(max-width: 900px)']).subscribe(result => {
      console.log("matches: " + result.matches);
      this.isMobile = result.matches;
    });
  }

  ngOnInit(): void {
  }

}
